<template>
  <div class="tv-bibding">
    <div class="bg"></div>
    <div class="content">
      <div class="form">
        <div class="form-item">
          <van-icon name="arrow" class="icon" />
          <input :value="orgName" @focus="handle2Search" type="text" placeholder="请选择您的学校" />
        </div>
        <div class="form-item">
          <input v-model="name" type="text" placeholder="请输入名称" />
        </div>
      </div>
      <div style="padding: 0 32px; margin-top: 30px">
        <van-button @click="handleBind" color="#4A86F6" round block type="primary">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {tvBindOrg} from '@/api'
export default {
  data() {
    return {
      code: '', // 设备编号
      servicePath: '',
      tenantId: '',
      name: '',
      orgId: '',
      orgName: ''
    }
  },
  created() {
    // code=123&servicePath=http%3A%2F%2Fysclass.net&tenantId=

    const {code, servicePath, tenantId, orgId, orgName, name} = this.$route.query
    this.code = code
    this.servicePath = decodeURIComponent(servicePath)
    this.tenantId = tenantId

    this.orgId = orgId
    this.orgName = orgName
    this.name = name
  },
  methods: {
    async handleBind() {
      if (!this.code || !this.servicePath) {
        return this.$Toast.fail('绑定失败，请重试')
      }
      if (!this.orgId) {
        return this.$Toast.fail('请选择机构')
      }
      const params = {
        code: this.code,
        name: this.name,
        orgId: this.orgId,
        servicePath: this.servicePath,
        tenantId: this.tenantId
      }
      const result = await tvBindOrg(params)
      if (result.code === 0) {
        this.$Toast.success('绑定成功')
        setTimeout(() => {
          this.$router.replace('/')
        }, 3000)
      }
    },
    handle2Search() {
      this.$router.push({
        path: '/tv/bindSearch',
        query: {
          code: this.code,
          servicePath: encodeURIComponent(this.servicePath),
          tenantId: this.tenantId,
          orgId: this.orgId,
          orgName: this.orgName,
          name: this.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tv-bibding {
  height: 100vh;
  background: #f8f8f8;
}
.bg {
  height: 110px;
  background: #4a86f6;
}
.content {
  position: relative;
  top: -32px;
  background: #f8f8f8;
  border-radius: 8px;
}
.form {
  overflow: hidden;
  position: relative;
  top: -32px;
  margin: 0 16px;
  background: #ffffff;
  border-radius: 8px;
}
.form-item:first-child {
  border-bottom: 1px solid #e6e6e6;
}
.form-item {
  position: relative;
  margin: 0 12px;
  height: 64px;
  .icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #c0c4cc;
  }
  input {
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    /* padding: 0 12px; */
    &::placeholder {
      color: #b3b3b3;
    }
  }
}
</style>
